// #region Actions
const actions = {
  async addRoutePoint({commit}, {point}) {
    commit('addRoutePoint', {point});
  },
  async addGlobalSearch({commit}, mode) {
    commit('addGlobalSearch', mode);
  },
  async reorderRoutePoints({commit}, payload) {
    commit('reorderRoutePoints', payload);
  },
  async removeRoutePoint({commit}, {id}) {
    commit('removeRoutePoint', {id});
  },
  async cleanRoutePoints({commit}) {
    commit('cleanRoutePoints');
  },
};
// #endregion

// #region Getters
// #endregion

// #region Mutations
const mutations = {
  addRoutePoint(state, {point}) {
    state.routePoints.push(point);
  },
  addGlobalSearch(state, mode) {
    state.globalSearch = mode;
  },
  reorderRoutePoints(state, {fromIndex, toIndex}) {
    const droppedItem = state.routePoints.splice(fromIndex, 1)[0];
    state.routePoints.splice(toIndex, 0, droppedItem);
  },
  removeRoutePoint(state, {id}) {
    state.routePoints = state.routePoints.filter((rp) => rp.id !== id);
  },
  cleanRoutePoints(state) {
    state.routePoints = [];
  },
};
// #endregion

// #region State
const state = () => {
  return {
    routePoints: [],
    globalSearch: false,
  };
};
// #endregion


// #region Etc
const namespaced = true;
const modules = []; // Submodules
// #endregion


export default {
  actions,
  // getters,
  modules,
  mutations,
  namespaced,
  state,
};
